import React from 'react'
import './about.css';
import Me from '../../assets/Me.jpg';
import { FaAward } from 'react-icons/fa';
import { VscOrganization } from 'react-icons/vsc';
import { MdDomainVerification } from 'react-icons/md';

const about = () => {
    return (
        <section id="about">
            <h5>Get to know</h5>
            <h2>About Me</h2>
            <div className='container about__container'>
                <div className='about__me'>
                    <div className='about__me-image'>
                        <img src={Me} alt='About Me' />
                    </div>
                </div>
                <div className='about__content'>
                    <div className='about__cards'>
                        <article className='about__card'>
                            <FaAward className='about__icon' />
                            <h5>Experience</h5>
                            <small>12 Years</small>
                        </article>
                        <article className='about__card'>
                            <VscOrganization className='about__icon' />
                            <h5>Organizations, Clients</h5>
                            <small>Fidelity</small>
                            <small>UHG</small>
                            <small>IHS Markit</small>
                            <small>S&P Global</small>
                            <small>Eli Lilly</small>
                        </article>
                        <article className='about__card'>
                            <MdDomainVerification className='about__icon' />
                            <h5>Domain Knowledge</h5>
                            <small>Fintech</small>
                            <small>Healthcare</small>
                            <small>LifeSciences</small>
                        </article>
                    </div>
                    <p> With twelve years of experience in the IT industry, I am a committed professional engineer and a
                        technology enthusiast currently employed at <strong>S&P Global</strong>. My career has mainly focused on projects
                        within the finance, healthcare, and insurance sectors. However, I am eager to expand my knowledge
                        and explore new areas.
                    </p>
                    <a href="#contact" className='btn btn-primary'>Let's talk</a>
                </div>
            </div>
        </section >
    )
}

export default about;